import { styled } from '@eneco/sparky/stitches';

export const StyledDisclaimerText = styled('div', {
  fontSize: '1.2rem',
  letterSpacing: '0px',
  lineHeight: '1.6rem',
  color: 'var(--colors-textLowEmphasis)',
  p: {
    marginBottom: '8px',
  },
});
